module.exports = __webpack_public_path__ + "static/home-brain-small-4e77b1e88abc70419adf0cfb41a316cf.svg";